import { AppBar, Box, Container, Toolbar, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import useAppShellSx from '../../hooks/useAppShellSx';
import AppHeaderBrand from './AppHeaderBrand';

export default function TestAppHeader({ logo, defaultLogo }) {
  const sx = useAppShellSx();
  const { header } = sx;

  return (
    <AppBar
      elevation={0}
      sx={{
        ...header.appBarTest,
        '&.MuiAppBar-root': { boxShadow: 'none' },
      }}
    >
      <Container maxWidth="xl">
        <Toolbar sx={header.toolbarTest}>
          <AppHeaderBrand
            logo={logo}
            defaultLogo={defaultLogo}
            variant="test"
          />

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'flex-end', sm: 'flex-end' },
              textAlign: 'right',
            }}
          >
            <Typography variant="body1" sx={header.brandTitleTest}>
              Powered by Machadalo
            </Typography>
            <Typography variant="body2" sx={header.brandSubtitleTest}>
              Brand owned by Vijaikirti Technologies Pvt. Ltd
            </Typography>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

TestAppHeader.propTypes = {
  logo: PropTypes.string,
  defaultLogo: PropTypes.string.isRequired,
};
